export const SHOW_SHORTCUTS = "SHOW_SHORTCUTS";
export const SET_STATE_SHORTCUTS = "SET_STATE_SHORTCUTS";
